module.exports = __webpack_public_path__ + "images/menu_26e0a403e26816bfb6c4927b5c55fbf9.svg";